import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { HermesTokenResult, RefreshTokenExchangeResult } from '@kaligo/hermes';
import { Store } from '@ngrx/store';
import { GUARDHOUSE_API_URL } from '@rd/core/tokens/rd-lib.token';
import { StartsWithHttps } from 'global-types';
import { Observable } from 'rxjs';
import { map, retryWhen } from 'rxjs/operators';
import { getAuthToken } from '../../auth/store/selectors/auth.selectors';
import { CoreState } from '../../store/reducers';
import { NydusNetworkErrorHandlerService } from '../nydus-network-error-handler/nydus-network-error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class GuardhouseApiDataService {
  tokenResult: HermesTokenResult | RefreshTokenExchangeResult | null;

  constructor(
    @Inject(GUARDHOUSE_API_URL) private guardhouseApiUrl: StartsWithHttps,
    private http: HttpClient,
    private store: Store<CoreState>,
    private errorHandler: NydusNetworkErrorHandlerService,
  ) {
    this.store
      .select(getAuthToken)
      .subscribe(
        (
          tokenResult: HermesTokenResult | RefreshTokenExchangeResult | null,
        ) => {
          this.tokenResult = tokenResult;
        },
      );
  }

  get<Response>(
    urlSuffix: string,
    params: HttpParams = new HttpParams(),
  ): Observable<Response> {
    return this.http
      .get<Response>(this.buildUrl(urlSuffix), {
        headers: this.buildHeaders(),
        params,
      })
      .pipe(
        map((res) => res),
        retryWhen((errors$) =>
          this.errorHandler.handleErrorStream(errors$, urlSuffix),
        ),
      );
  }

  private buildUrl(urlSuffix: string): string {
    return `${this.guardhouseApiUrl}/${urlSuffix}`;
  }

  private buildHeaders(): { [key: string]: string | string[] } {
    const headers = {
      'Content-Type': 'application/json',
    };
    const tokenResult = this.tokenResult
      ? { Authorization: `Bearer ${this.tokenResult.accessToken}` }
      : undefined;

    return {
      ...headers,
      ...tokenResult,
    };
  }
}
